export var IQrWecomLoginStatus = /*#__PURE__*/function (IQrWecomLoginStatus) {
  IQrWecomLoginStatus["IFRAME_MESSAGE_CONNECTED"] = "IFRAME_MESSAGE_CONNECTED";
  IQrWecomLoginStatus["IFRAME_DOM_MOUNTED"] = "IFRAME_DOM_MOUNTED";
  IQrWecomLoginStatus["USER_HAS_CONFIRMED"] = "USER_HAS_CONFIRMED";
  IQrWecomLoginStatus["GOT_CHANGE_KEY"] = "GOT_CHANGE_KEY";
  IQrWecomLoginStatus["LOGIN_SUCCESS"] = "LOGIN_SUCCESS";
  IQrWecomLoginStatus["ERROR"] = "ERROR";
  return IQrWecomLoginStatus;
}({});
//# sourceMappingURL=wework-login.js.map